import { buildExcelExportURL } from '@/util/api'; 

export default {
  appTitle: 'Development Applications Search',
  resultsTitle: 'Search Results',
  advSearchTitle: 'Advanced Search',
  detailsTitle: 'Application Details',
  feedbackTitle: 'Application Feedback',
  faqTitle: 'Frequently Asked Questions',
  termsTitle: 'Terms of Use',
  opensInNewWindow: 'Opens in a new window',
  switchLanguage: 'Voir en français',
  feedbackSurveyText: 'Feedback Survey',
  feedbackSurveyLink: 'https://s-ca.chkmkt.com/?e=204244&h=3E5C3B684B26E7C&l=en',
  feedbackSurveyAriaLabel: 'Feedback Survey',
  oldWebsiteText: 'Old Development Application Search',
  oldWebsiteLink: 'https://app01.ottawa.ca/postingplans/home.jsf?lang=en',
  oldWebsiteAriaLabel: 'Old Development Application Search',
  download: {
    text: 'Download all Development Application data',
    link: buildExcelExportURL(),
    title: 'Confirm Download',
    message: 'You are about to download complete Development Applications data in Microsoft Excel format. Click "Yes" to continue',
    yes: 'Yes',
    no: 'No',
  },
  header: {
    signInButton: 'Sign-in',
    menuLinks: [
      {
        text: 'Class and activity registration',
        href: 'https://apps102.ottawa.ca/Activities/ActivitiesAdvSearch.asp?SCheck=109982093&SDT=38804.5054050926&LanguageId=1&LanguageIndex=1',
        active: false
      },
      {
        text: 'Jobs with the City',
        href: 'https://ottawa.ca/en/jobs-city',
        active: false
      },
      {
        text: 'My ServiceOttawa',
        href: 'https://myservice.ottawa.ca/profile/account/login?lang=en',
        active: false
      },
    ],
  },
  breadcrumb: {
    home: 'Home',
    homeLink: 'https://ottawa.ca/en',
    planAndDevelop: 'Planning, development and construction',
    planAndDevelopLink: 'https://ottawa.ca/en/planning-development-and-construction',
    neighbour: 'What\'s happening in your neighbourhood',
    neighbourLink: 'https://ottawa.ca/en/planning-development-and-construction/whats-happening-your-neighbourhood',
    thisTool: 'Development applications search' 
  },
  footer: {
    navTitle: 'Footer links',
    contactUsText: 'Contact Us',
    contactUsLink: 'https://ottawa.ca/en/city-hall/your-city-government/contact-us',
    disclaimerText: 'Disclaimer',
    disclaimerLink: 'https://ottawa.ca/en/disclaimer',
    privacyText: 'Privacy',
    privacyLink: 'https://ottawa.ca/en/city-hall/accountability-and-transparency/accountability-framework/freedom-information-and-protection-privacy/protection-privacy#privacy-statement',
    accessibilityText: 'Accessibility',
    accessibilityLink: 'https://ottawa.ca/en/city-hall/accessibility-services',
    ottawaCaText: 'Visit ottawa.ca',
    ottawaCaLink: 'https://ottawa.ca/en'
  },
  search: {
    form: {
      textLabel: 'Search by address, application number or ward.  For other search options, ',
      linkLabel: 'please see FAQ.',
      buttonText: 'Search',
      streetNameText: 'Street Name', 
      wardText: 'Ward', 
      applicationTypeText: 'Application Type', 
      applicationNumberText: 'Application Number', 
      keywordText: 'Keywords',
      activeDevAppText: 'Active Applications Only',
      inactiveDevAppText: 'Inactive Applications Only',
      allDevAppText: 'Active/Inactive Applications',
      applicationStatus: 'Application Status',
      option: 'Search Term, Street Name, or Application Number',
      all: 'All',
      findWardText: 'Find a Ward',
      findWardLink: 'https://ottawa.ca/findaward',
      findWardAriaLabel: 'Find a Ward',
      linkIsExternal: '(link is external)'
    },
    results: {
      loading: 'Loading results',
      searching: 'Searching ...',
      header: 'Results',
      clearButtonText: 'Reset',
      clearButtonAriaLabel: 'Clear the results of this search and return to the search form',
      moreButtonText: 'Details',
      moreButtonAriaLabel: 'Application Number _APP_NUM_ show more details',
      closest: 'Closest Development Applications',
      appStatus: 'Application Status',
      applicationNumber: 'Application # ',
      addressFriendly: 'Address',
      addressFriendlyPlural: 'Addresses',
      applicationType: 'Application Type',
      currentStatus: 'Review Status',
      date: 'Status Date',
      wardPrefix: 'Ward',
      canComment: '(Open for Comments)',
      cannotComment: '(Closed for Comments)',
      nextPage: 'Next Page',
      previousPage: 'Previous Page',
      of: 'of',
      ascending: 'Ascending',
      descending: 'Descending',
      relevance: 'Relevance',
      noResults: 'No Results Found',
      orderBy: 'Order by:'
    }
  },
  devapp: {
    details: {
      loading: 'Loading details',
      header: 'Application # ',
      viewSearchButtonLabel: 'Back to search',
      viewSearchButtonAriaLabel: 'Return to the search results',
      closeButtonLabel: 'Close',
      closeButtonAriaLabel: 'Clear the details and return to the search form',
      feedbackButtonLabel: 'Send Feedback',
      feedbackButtonAriaLabel: 'Send feedback to the file lead',
      cancelButtonLabel: 'Cancel',
      cancelButtonAriaLabel: 'Cancel sending feedback',
      info: {
        heading: 'Details',
        appNum: 'Application #',
        appStatus: 'Application Status',
        receivedDate: 'Date Received',
        address: 'Address',
        addressPlural: 'Addresses',
        ward: 'Ward',
        appType: 'Application',
        objStatus: 'Review Status',
        circulationEnd: 'Comment Timeline',
        circulationEndNote: 'Please provide comments by',
        statusDate: 'Status Date',
        description: 'Description',
      },
      fileLead: {
        heading: 'File Lead',
        name: 'Name',
        phone: 'Phone',
        sendComments: 'Send comments to the file lead',
      },
      docs: {
        heading: 'Supporting Documents',
        text: 'Requirements for supporting documentation vary according to application type and proposal complexity. As a result, some proposals warrant the collection of studies and plans while others do not. The need for supporting documentation is typically outlined for applicants prior to the submission of an application. Where possible, a plan illustrating the proposal has been provided. If you have questions relating to supporting documentation, please contact the file lead.',
        conditionsShort: 'The following reports, studies and related documentation are subject to some conditions. (Click to view)',
        conditionsLong: 'The reports, studies and related documentation provided in support of this application are being made available in the language submitted by the applicant. They are PRELIMINARY, and have not received the endorsement or approval of the City of Ottawa. The reports, studies and related documentation are under technical review by City staff and other applicable agencies, and may be subject to significant revisions. The City will make every effort to post new information on development applications on this site as the information becomes available; however, users must be aware that some delays may occur.<br><br>Information contained on this Website is provided for convenience only. The purpose of the Web site is to allow for greater public access to information concerning development applications that have been submitted to the City of Ottawa. Some of the information contained on this Web site has not been created by the City of Ottawa, and therefore, the City of Ottawa and its employees do not guarantee or represent that the information is accurate, complete, up-to-date, or that it is free of any errors, viruses, or other items of any kind that are of a destructive nature.<br><br>The City assumes no responsibility for errors or omissions contained in any of the information posted on this Web site. Any use of or reliance on the Web site and all contents is solely at the user\'s own risk. In no event shall the City be liable for any damages of any kind arising out of or in relation to Web site or its contents, the City\'s failure to update the Web site or any inability to use the Web site.<br><br>Users should be aware that the use of reports, studies or documentation may be subject to restrictions under the Copyright Act or other applicable law.<br><br>Please note that development applicants and interested parties should contact the file lead for confirmation of the status of the development application. Interested parties must contact the City in writing, using the online form, fax, or mail, should notice of a public meeting held by the Planning Services or notice of a decision on a development application be desired. ',
        count: 'attachment',
        countPlural: 'attachments'
      },
    }
  }
}
